import { assetsIcons } from "assets";
import moment from "moment";
import { FormatDateApi, FormatDateType } from "shared/models";
import dayjs from "dayjs";
export const DAYS_EXPIRED_COOKIE = 30;
export const DAYS_EXPIRED_TOKEN = 1;
export const LIMIT = 10;

export const INIT_SEARCH = {
  page: 1,
  limit: LIMIT,
  searchText: "",
};

export const ASC = "ascend";
export const DESC = "descend";

export const SIZE_RECORDS = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" },
  { label: "100", value: "100" },
];

export enum LengthInputDefault {
  lengthDefault = 100,
  lengthAddress = 200,
  lengthPhoneNumber = 20,
}

export enum MessageValidate {
  requiredField = "This field is required.",
  numberGreaterThan0 = "Please enter a number >= 0",
  numberGreaterThanZero = "The amount must be greater than 0.",
  amountGreaterThan0 = "Please enter a number > 0.",
  requiredEmail = "Please enter your email.",
  requiredPassword = "Please enter your password.",
  requireConfirmPassword = "Please enter confirm password",
  passwordRule = "Please enter a password followed at least 3 out of 4 rules",
  duplicateEmail = "Duplicated email found in the system",
  duplicateRegisterBusiness = "Duplicated registered business name found in the system",
  validEmail = "Please enter a valid email address.",
  validNumber = "Please enter a valid number",
  validEmailFormat = "Please enter a valid email",
  confirmPassword = "New passwords and confirming passwords are not the same.",
  lengthPassword = "Please enter a password with at least 8 characters",
  toastCodeGA = "Please enter the code you see from Google Authenticator",
  toastCodeEmail = "Enter the verification code that has been sent to your email",
  between0to10 = "Only allow value between 0 - 10",
  uploadFileMax5 = "Please upload maximum 5 files.",
  maximum5FilesAllowed = "Only maximum 5 files are allowed.",
  validUrl = "Please input the url in the correct format.",
  checkFieldIsOutOfRange = "This value is out of range.",
  validPhoneNumber = "Please enter a valid phone number.",
  validPhone = "Please enter a valid phone.",
  validPSPChannel = "At least one PSP channel is required.",
}

export type NotificationType = "success" | "info" | "warning" | "error";
export type NotificationPlacement = 'top' | 'topLeft' | 'topRight' | 'bottom' | 'bottomLeft' | 'bottomRight';

export enum PermissionType {
  dashboard = "dashboard",
  settings = "settings",
  adminUsers = "admin.users",
  adminPartners = "admin.partners",
  adminMerchants = "admin.merchants",
  adminSystemLog = "admin.system_logs",
  merchantSettings = "merchants.settings",
  customerManagement = "merchants.customers",
  merchantNotifications = "merchants.notifications",
  merchantAuditLogs = "merchants.audit_logs",
  reportTransactions = "report.transactions",
  reportDisbursements = "report.disbursements",
  apiConnection = "api_connection",
  reportAutoCharge = "report.auto_charge",
  virtualTerminal = "virtual_terminal",
  partnerSettings = "partners.settings",
  partnerOnboarding = "partner_onboarding",
  onboardingSettings = "onboardings.settings",
  communicationSettings = "communications.settings",
  chargebackReport = "chargeback_report",
  adminCrossCheck = "admin.cross_check",
  merchantVirtualTerminal = "merchants.virtual_terminal",
  receivable = "admin.receivable",
  vaultService = 'vaultService',
  refundTransaction = 'refund.transactions',
  urlManagement = "url_management",
  paymentSettings = 'paymentSettings',
  viewCard = 'view.card',
}

export enum NavigateType {
  LIST = "LIST",
  DETAIL = "DETAIL",
  CREATE = "CREATE",
  EDIT = "EDIT",
}

export enum StatusNotification {
  ACTIVATE = "activate",
  DEACTIVATE = "deactivate",
}

export enum NavigateProfileTab {
  USER_DETAIL_KEY_TAB = "user-details",
  API_KEY_TAB = "api-key",
  TWO_FA_KEY_TAB = "two-fa",
}

export type MetaPagination = {
  current_page?: number;
  last_page?: number;
  per_page?: number;
  total?: number;
};

export const PAYMENT_ICONS_LIGHT: any = {
  affirm: assetsIcons.payments.light.affirm,
  afterPay: assetsIcons.payments.light.afterPay,
  amazon: assetsIcons.payments.light.amazon,
  amex: assetsIcons.payments.light.amex,
  applePay: assetsIcons.payments.light.applePay,
  bitcoin: assetsIcons.payments.light.bitcoin,
  diners: assetsIcons.payments.light.diners,
  discover: assetsIcons.payments.light.discover,
  googlePay: assetsIcons.payments.light.googlePay,
  jcb: assetsIcons.payments.light.jcb,
  mastercard: assetsIcons.payments.light.mastercard,
  paypal: assetsIcons.payments.light.paypal,
  prime: assetsIcons.payments.light.prime,
  shop: assetsIcons.payments.light.shop,
  stripe: assetsIcons.payments.light.stripe,
  visa: assetsIcons.payments.light.visa,
};

export const FileName = {
  TransactionCsv: `Transaction Report`,
  DisbursementCsv: `Payout Report`,
  ChargeAutomationCsv: `Charge Automation Report`,
  ChargebackCsv: `Chargeback Report`,
  KYCReviewPdf: `KYC Detail`,
  KYCListingCsv: `KYC Report`,
  ReceivableCsv: `Receivables Report`,
  PaymentInfoCsv: `Payment Info`,
  KYCSignupInfo: `Merchant Signup Info`,
};

export enum StatusResponeApi {
  BAD_REQUEST = 400,
  AUTHORIZED = 401,
  NOT_FOUND = 404,
  SUCCESS = 200,
  INTERNAL_SERVER_ERROR = 500,
}

export enum RegexValidation {
  validEmail = '^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)+$',
  validUrl = '^https:\\/\\/(www\\.)?[a-zA-Z0-9-_]+\\.[a-zA-Z]{2,}([\\./a-zA-Z0-9-_+]*)?$',
  validPhoneNumber = '^\\d+$',
  validPhone = '^\\+?\\d{1,4}?[-.\\s]?\\(?\\d{1,3}?\\)?[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,9}$'
}


export const surchargeModeList = ["No surcharge","Grossed up surcharge","Card brand / Wallet surcharge"];

export const checkNumberBetween = (_: any, value: number, min: number, max: number) => {
  if(value){
    if (value >= min && value <= max) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(`Only allow value between ${min} - ${max}.`));
  }
  else{
    return Promise.reject(new Error(MessageValidate.requiredField));
  }

};

export const SUPPORT_CARD_BRANDS = [
  { label: assetsIcons.payments.light.visa, value: "VIS" },
  { label: assetsIcons.payments.light.mastercard, value: "ECA" },
  { label: assetsIcons.payments.light.amex, value: "AMX" },
  { label: assetsIcons.payments.light.jcb, value: "JCB" },
  { label: assetsIcons.payments.light.cup, value: "CUP" },
];

export const checkAmountGreaterThan0 = (_: any, value: any) => {
  if (value === undefined || value === null) {
    return Promise.reject(new Error(MessageValidate.requiredField));
  }
  if (value >= 0) {
    const regex = /^\d{1,12}(\.\d{1,2})?$/;
    if (!regex.test(value)) {
      return Promise.reject('The amount is out of range.');
    }
    return Promise.resolve();
  }
  return Promise.reject(new Error(MessageValidate.numberGreaterThan0));
};

export const checkFxRateGreaterThan0 = (_: any, value: any) => {
  if (value === undefined || value === null) {
    return Promise.reject(new Error(MessageValidate.requiredField));
  }
  if (value > 0) {
    const regex = /^\d{1,12}(\.\d{1,10})?$/;
    if (!regex.test(value)) {
      return Promise.reject('The amount is out of range.');
    }
    return Promise.resolve();
  }
  return Promise.reject(new Error(MessageValidate.numberGreaterThan0));
};

export const dateRangeLimit = (_: any, value: any) => {
  if(value){
    const minDate = moment("1970-01-01").startOf('day');
    const maxDate = moment().add(10, 'years').endOf('day');
    const newValue = value.clone().startOf('day');
    
    if (newValue.isBefore(minDate, 'days') || newValue.isAfter(maxDate, 'days')) {
      return Promise.reject('This value is out of range.');
    }
  }
  
  return Promise.resolve();
}